import { usePerfilOficialSectionsStore } from '~/stores/apostatudo/perfil-oficial-sections';
import { fetchPerfilOficialSectionsHandler } from '~/handlers/fetch-perfil-oficial-sections.handler';

export const usePerfilOficialSections = () => {
  const store = usePerfilOficialSectionsStore();

  const fetchSections = async (slug: string) => {
    // Se já tem dados para este slug, não refaz requisição
    if (store.currentSlug === slug && store.hasItems) return;

    // Slug diferente → resetar dados anteriores antes de buscar
    if (store.currentSlug !== slug) {
      store.reset();
    }

    store.loading = true;
    store.error = null;
    store.currentSlug = slug;

    try {
      // Tenta buscar pelo slug original (ex: "padrinho")
      const { sections } = await fetchPerfilOficialSectionsHandler({
        slug,
      });

      if (sections) {
        store.setSectionData(sections);

        return;
      }

      // Se não encontrou, tenta com prefixo "home-" (ex: "home-padrinho")
      const prefixedSlug = `home-${slug}`;
      const { sections: prefixedSections } =
        await fetchPerfilOficialSectionsHandler({
          slug: prefixedSlug,
        });

      if (prefixedSections) {
        store.setSectionData(prefixedSections);

        return;
      }

      // Nenhuma variante encontrada → fallback para perfilOficialConfigs
      store.error = 'Nenhum dado retornado pela API';
    } catch (error) {
      console.error('[usePerfilOficialSections] Erro:', error);
      store.error =
        error instanceof Error ? error.message : 'Erro desconhecido';
    } finally {
      store.loading = false;
    }
  };

  return {
    fetchSections,
    sortedItems: computed(() => store.sortedItems),
    validItems: computed(() => store.validItems),
    hasItems: computed(() => store.hasItems),
    loading: computed(() => store.loading),
    error: computed(() => store.error),
  };
};
